"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

require("core-js/modules/es.array.join");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _queryBuilderFeathers = _interopRequireDefault(require("./queryBuilderFeathers"));

var _queryBuilderMlkl = _interopRequireDefault(require("./queryBuilderMlkl"));

var DIALECT_NONE = 'none';
var DIALECT_MLKL = 'moleculer';
var DIALECT_FTHRS = 'feathers';
var dialect = DIALECT_NONE;
var isAsync = false;

var mergeOptions = function mergeOptions(options) {
  return (0, _extends2.default)({
    async: isAsync
  }, options || {});
};
/**
 * Zbuildi query string do zvoleneho dialektu.
 *
 * @param {Array<FilterField>} [filter] Filter field muze byt
 * 1. `{ field: string, value: *, toQuery?: (value, fieldName) => Object }` Pokud existuje filterField a ma
 *      funkci `toQuery` pro konverzi bude pouzita tato funkce. V opacnem pripade bude `field` a `value` prevedena na
 *      `queryField` pomoci postupu:
 *   a. `value` je `undefined` => `notExistsToQuery`
 *   b. `value` neni `Array` a neni `undefined` => `equalToQuery`
 *   c. `value` je `Array` a neni `undefined` => `inToQuery`
 * 2. `function` se signaturou `() => Object`, ktera se chova podobne jako `toQuery`.
 *
 * @param {Object} [order]
 * @param {string} order.orderBy Nazev fieldu, dle ktereho se bude radit vysledek
 * @param {'asc' | 'desc'} order.orderDirection, alternative
 * @param {string} order.alternative Alternativni nazev fieldu.
 *
 * @param {Object} [pagination]
 * @param {number} pagination.page Cislo stranky pro vraceni. Stranky jsou cislovany od 1.
 * @param {number} pagination.rowsPerPage Pocet zaznamu na stranku.
 *
 * @param {Object} [options]
 * @param {`none` | `moleculer` | `feathers`} [options.dialect]
 * @param {boolean} [options.async=false] Pokud je `true` navratova hodnota queryBuilder je `Promise`.
 */


function queryBuilder(options, filter, order, pagination) {
  var _ref = options || {},
      oDialect = _ref.dialect,
      opts = (0, _objectWithoutProperties2.default)(_ref, ["dialect"]);

  var uDialect = oDialect || dialect;
  if (uDialect === DIALECT_MLKL) return (0, _queryBuilderMlkl.default)(mergeOptions(opts), filter, order, pagination);
  if (uDialect === DIALECT_FTHRS) return (0, _queryBuilderFeathers.default)(mergeOptions(opts), filter, order, pagination); // eslint-disable-next-line no-console

  console.error(["Prease set up 'queryBuilder' before first use.", "Usually in root index.js call one of presets 'queryBuilder.mlklSyncPreset()',", "'queryBuilder.mlklAsyncPreset()', 'queryBuilder.feathersSyncPreset()'", "or 'queryBuilder.feathersAsyncPreset()'"].join(' '));
  return undefined;
}

queryBuilder.mlklSyncPreset = function () {
  dialect = DIALECT_MLKL;
  isAsync = false;
};

queryBuilder.mlklAsyncPreset = function () {
  dialect = DIALECT_MLKL;
  isAsync = true;
};

queryBuilder.feathersSyncPreset = function () {
  dialect = DIALECT_FTHRS;
  isAsync = false;
};

queryBuilder.feathersAsyncPreset = function () {
  dialect = DIALECT_FTHRS;
  isAsync = true;
};

var _default = queryBuilder;
exports.default = _default;